import React from "react";
import { useLocation } from "react-router-dom";

import Loading from "../components/Loading/Loading";
import { useOidcUserContext } from "../contexts/OidcUserContext";

const OidcAuthGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { oidcUser, loadingOidcUser, signinRedirect, clearStaleState } = useOidcUserContext();

  if (loadingOidcUser) return <Loading />;

  if (!oidcUser) {
    const currentUrl = location.pathname + location.search;

    // Clear any remaining stale PKCE/state entries to start login
    clearStaleState()
      .then(() => {
        signinRedirect(currentUrl);
      })
    return null;
  }

  return <>{children}</>;
};

export default OidcAuthGuard;
